import React, { useCallback, useEffect, useState } from 'react';
import { yapiKampanyalar, yapiSetler, yapiReklamlar, yapiKlonla, yapiOnizleme, yapiDurum, yapiAd } from '../../services/reklamApi';

// HESAP YAPISI — kullanıcı talebi: 2026-09-06.
// "Kampanya - setler - reklamlar sıralansın, dilediğime KLONLA diyeyim, isim sorsun, klonu oluştursun."
//
// Neden gerekti: kendi setlerimizi (ŞÜKRÜ ÖZEL) açmak için her seferinde Meta paneline giriliyordu.
// Çalışan bir setin kopyasını almak en güvenli yol — hedefleme, hariç tutulan kitleler, yerleşimler
// olduğu gibi gelir; sıfırdan kurarken bunların biri unutulur.
//
// Ağaç TEK SEFERDE çekilmez: hesapta 25 kampanya, yüzlerce set var. Her düğüm açıldığında sorulur.
export default function Yapi() {
  const [kampanyalar, setKampanyalar] = useState([]);
  const [durum, setDurum] = useState('yukleniyor');
  const [mesaj, setMesaj] = useState('');

  // id -> { acik, yukleniyor, cocuklar }
  const [setler, setSetler] = useState({});
  const [reklamlar, setReklamlar] = useState({});

  // Klon penceresi: hangi nesne, ne ad, reklamlar da gelsin mi
  const [klon, setKlon] = useState(null);
  const [klonAd, setKlonAd] = useState('');
  const [klonReklamlar, setKlonReklamlar] = useState(false);
  const [klonlaniyor, setKlonlaniyor] = useState(false);

  const [sadeceAktif, setSadeceAktif] = useState(true);   // varsayılan: yalnızca yayındakiler (2026-09-29)

  // Reklamın görüntüsü kendi ekranımızda (kullanıcı talebi: 2026-09-06).
  const [onizleme, setOnizleme] = useState(null);       // { reklam, kareler, yukleniyor, hata }
  // Adı değiştirilen nesne (kullanıcı talebi: 2026-09-06): { tur, dugum, tazele }
  const [adDegis, setAdDegis] = useState(null);
  const [yeniAd, setYeniAd] = useState('');
  const [adKaydediliyor, setAdKaydediliyor] = useState(false);

  // Durumu değiştirilen nesne — düğme iki kez basılmasın diye.
  const [durumIslemde, setDurumIslemde] = useState(null);

  const yukle = useCallback(() => {
    setDurum('yukleniyor');
    yapiKampanyalar()
      .then(r => { setKampanyalar(r.data.kampanyalar || []); setDurum('hazir'); })
      .catch(e => { setMesaj('✗ ' + (e.response?.data?.hata || e.message)); setDurum('hata'); });
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const setleriAc = (k) => {
    const mevcut = setler[k.id];
    if (mevcut?.acik) { setSetler(s => ({ ...s, [k.id]: { ...mevcut, acik: false } })); return; }
    if (mevcut?.cocuklar) { setSetler(s => ({ ...s, [k.id]: { ...mevcut, acik: true } })); return; }

    setSetler(s => ({ ...s, [k.id]: { acik: true, yukleniyor: true } }));
    yapiSetler(k.id)
      .then(r => setSetler(s => ({ ...s, [k.id]: { acik: true, cocuklar: r.data.setler || [] } })))
      .catch(e => {
        setSetler(s => ({ ...s, [k.id]: { acik: true, cocuklar: [] } }));
        setMesaj('✗ ' + (e.response?.data?.hata || e.message));
      });
  };

  const reklamlariAc = (st) => {
    const mevcut = reklamlar[st.id];
    if (mevcut?.acik) { setReklamlar(s => ({ ...s, [st.id]: { ...mevcut, acik: false } })); return; }
    if (mevcut?.cocuklar) { setReklamlar(s => ({ ...s, [st.id]: { ...mevcut, acik: true } })); return; }

    setReklamlar(s => ({ ...s, [st.id]: { acik: true, yukleniyor: true } }));
    yapiReklamlar(st.id)
      .then(r => setReklamlar(s => ({ ...s, [st.id]: { acik: true, cocuklar: r.data.reklamlar || [] } })))
      .catch(e => {
        setReklamlar(s => ({ ...s, [st.id]: { acik: true, cocuklar: [] } }));
        setMesaj('✗ ' + (e.response?.data?.hata || e.message));
      });
  };

  const onizlemeAc = (r) => {
    setOnizleme({ reklam: r, yukleniyor: true });
    yapiOnizleme(r.id)
      .then(x => setOnizleme({ reklam: r, kareler: x.data.onizlemeler || [] }))
      .catch(e => setOnizleme({ reklam: r, hata: e.response?.data?.hata || e.message }));
  };

  // AKTİF/PASİF — canlı hesapta gerçek para etkisi olduğu için onay sorulur.
  // Meta hiyerarşisi: bir nesneyi açmak üstündekiler kapalıysa yayına çıkarmaz;
  // sunucu gerçek durumu döndürüyor, mesajda aynen gösteriyoruz.
  const durumDegistir = (tur, dugum, aktif, tazele) => {
    const ad = tur === 'kampanya' ? 'Kampanya' : tur === 'set' ? 'Reklam seti' : 'Reklam';
    if (!window.confirm(
      `${ad} ${aktif ? 'YAYINA ALINSIN' : 'DURDURULSUN'} mu?\n\n${dugum.ad}` +
      (aktif ? '\n\nDikkat: yayına alınca gerçek bütçe harcanmaya başlar.' : '')
    )) return;

    setDurumIslemde(dugum.id);
    setMesaj('');
    yapiDurum(dugum.id, aktif)
      .then(r => { setMesaj('✓ ' + r.data.mesaj); if (tazele) tazele(); })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)))
      .finally(() => setDurumIslemde(null));
  };

  // Bir dalın listesini yeniden okur — durum değişince rozet güncellensin.
  const setleriTazele = (kampanyaId) => {
    yapiSetler(kampanyaId)
      .then(r => setSetler(s => ({ ...s, [kampanyaId]: { acik: true, cocuklar: r.data.setler || [] } })))
      .catch(() => {});
  };
  const reklamlariTazele = (setId) => {
    yapiReklamlar(setId)
      .then(r => setReklamlar(s => ({ ...s, [setId]: { acik: true, cocuklar: r.data.reklamlar || [] } })))
      .catch(() => {});
  };

  // AD DEĞİŞTİRME — ad yalnızca etikettir; yayını, bütçeyi, öğrenme evresini etkilemez,
  // bu yüzden onay penceresi yok. Meta'daki ad değişir, ağaç yeniden okunur.
  const adAc = (tur, dugum, tazele) => {
    setAdDegis({ tur, dugum, tazele });
    setYeniAd(dugum.ad);
    setMesaj('');
  };

  const adKaydet = () => {
    setAdKaydediliyor(true);
    yapiAd(adDegis.dugum.id, yeniAd.trim())
      .then(r => {
        setMesaj('✓ ' + r.data.mesaj);
        setAdDegis(null);
        if (adDegis.tazele) adDegis.tazele();
      })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)))
      .finally(() => setAdKaydediliyor(false));
  };

  // Klon penceresini açar. hedefId: set klonunda hedef kampanya, reklam klonunda hedef set —
  // boş bırakılırsa Meta kopyayı kaynağın yanına açar.
  const klonAc = (tur, dugum, hedefId, hedefAdi) => {
    setKlon({ tur, dugum, hedefId, hedefAdi });
    setKlonAd(dugum.ad + ' - kopya');
    setKlonReklamlar(false);
    setMesaj('');
  };

  const klonla = () => {
    setKlonlaniyor(true);
    yapiKlonla({
      tur: klon.tur,
      kaynakId: klon.dugum.id,
      yeniAd: klonAd.trim(),
      hedefId: klon.hedefId || undefined,
      reklamlarlaBirlikte: klon.tur === 'set' ? klonReklamlar : false,
    })
      .then(r => {
        setMesaj('✓ ' + r.data.mesaj);
        setKlon(null);
        // Klon kaynağın yanına düştüğü için o dalın listesi tazelenir.
        if (klon.tur === 'kampanya') yukle();
        if (klon.tur === 'set') setSetler(s => ({ ...s, [klon.hedefId || klon.kampanyaId]: undefined }));
        setSetler({});
        setReklamlar({});
      })
      .catch(e => setMesaj('✗ ' + (e.response?.data?.hata || e.message)))
      .finally(() => setKlonlaniyor(false));
  };

  const ROZET = (d) => {
    const aktif = d === 'ACTIVE';
    const kapali = ['PAUSED', 'ADSET_PAUSED', 'CAMPAIGN_PAUSED', 'ARCHIVED', 'DELETED'].includes(d);
    return {
      fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 999,
      background: aktif ? '#EAF6F0' : kapali ? '#FDECEA' : '#FFF6E5',
      color: aktif ? '#1D7A56' : kapali ? '#C0392B' : '#8A6D1F',
      whiteSpace: 'nowrap',
    };
  };

  // DÜĞME SATIRIN BAŞINDA (kullanıcı: 2026-09-06). Sağa yaslandığında ad ile düğme arasında
  // koca bir boşluk kalıyordu; geniş ekranda doğru satırı tutturmak zordu. Sabit genişlik,
  // üç seviyede de aynı hizada dursun diye.
  const KLON_DUGME = {
    border: '1px solid #1F6FB2', background: '#fff', color: '#1F6FB2',
    borderRadius: 5, padding: '3px 10px', fontSize: 11, fontWeight: 700,
    cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, width: 76, textAlign: 'center',
  };

  const AD_DUGME = {
    border: 'none', background: 'none', cursor: 'pointer', padding: '0 2px',
    fontSize: 12, color: 'var(--text-muted)', flexShrink: 0, lineHeight: 1,
  };

  const DURUM_DUGME = (aktif) => ({
    border: `1px solid ${aktif ? '#C0392B' : '#1D7A56'}`,
    background: '#fff', color: aktif ? '#C0392B' : '#1D7A56',
    borderRadius: 5, padding: '3px 9px', fontSize: 11, fontWeight: 700,
    cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, width: 66, textAlign: 'center',
  });

  // Satır çizgileri: göz kaydırırken hangi satırda olduğunuz belli olsun (kullanıcı isteği).
  const SATIR = (derinlik) => ({
    display: 'flex', alignItems: 'center', gap: 9, flexWrap: 'wrap',
    padding: derinlik === 0 ? '9px 12px' : '6px 12px',
    borderTop: '1px solid var(--border)',
    background: derinlik === 2 ? '#FAFBFC' : '#fff',
  });

  // SÜZGEÇ HER ÜÇ SEVİYEYE BİRDEN UYGULANIR — kullanıcı uyarısı: 2026-09-29
  // ("pasifleri gösterme tikini işaretlediğimde GÖSTERME"). Önceden yalnızca kampanyaları
  // süzüyordu; bir kampanyayı açınca altından 629 duraklatılmış set dökülüyordu.
  const gorunen = sadeceAktif ? kampanyalar.filter(k => k.durum === 'ACTIVE') : kampanyalar;
  const suz = (liste) => (sadeceAktif ? (liste || []).filter(x => x.durum === 'ACTIVE') : (liste || []));
  const para = (kurus) => (kurus / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' ₺';

  return (
    <div>
      <h3 style={{ fontSize: 15, fontWeight: 600, marginBottom: 4 }}>Hesap Yapısı</h3>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 12 }}>
        Kampanya → reklam seti → reklam. İstediğiniz satırda <strong>KLONLA</strong> deyin, ad verin;
        kopya <strong>durdurulmuş</strong> olarak açılır — hedefleme, hariç tutulan kitleler ve
        yerleşimler aynen gelir. Kaynağa dokunulmaz, tek kuruş harcanmaz.
      </div>

      {mesaj && (
        <div style={{
          fontSize: 12.5, fontWeight: 600, marginBottom: 12, padding: '8px 11px', borderRadius: 6,
          background: mesaj.startsWith('✗') ? '#FDECEA' : '#EAF6F0',
          color: mesaj.startsWith('✗') ? '#C0392B' : '#1D7A56',
          border: `1px solid ${mesaj.startsWith('✗') ? '#E6A9A2' : '#9FD3BB'}`,
        }}>{mesaj}</div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10, flexWrap: 'wrap' }}>
        <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={sadeceAktif} onChange={e => setSadeceAktif(e.target.checked)} />
          Yalnızca yayındakileri göster (kampanya, set ve reklam)
        </label>
        <button onClick={yukle} style={{
          background: 'none', border: 'none', color: '#1F6FB2', fontSize: 11.5,
          textDecoration: 'underline', cursor: 'pointer', padding: 0,
        }}>listeyi yenile</button>
        <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{gorunen.length} kampanya</span>
      </div>

      {durum === 'yukleniyor' ? (
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>⏳ Meta'dan okunuyor...</div>
      ) : (
        <div style={{ border: '1px solid var(--border)', borderRadius: 8, background: '#fff' }}>
          {gorunen.map(k => {
            const dal = setler[k.id];
            return (
              <div key={k.id} style={{ borderBottom: '1px solid var(--border)' }}>
                <div style={{ ...SATIR(0), background: '#F7F9FA' }}>
                  <button onClick={() => setleriAc(k)} style={{
                    width: 22, height: 22, border: '1px solid var(--border)', background: '#fff',
                    borderRadius: 5, cursor: 'pointer', fontSize: 13, lineHeight: 1, flexShrink: 0,
                  }}>{dal?.acik ? '−' : '+'}</button>
                  <button onClick={() => klonAc('kampanya', k)} style={KLON_DUGME}>KLONLA</button>
                  <button disabled={durumIslemde === k.id}
                    onClick={() => durumDegistir('kampanya', k, k.durum !== 'ACTIVE', yukle)}
                    style={DURUM_DUGME(k.durum === 'ACTIVE')}>
                    {k.durum === 'ACTIVE' ? 'PASİF YAP' : 'AKTİF YAP'}
                  </button>
                  <strong style={{ fontSize: 13 }}>{k.ad}</strong>
                  <button title="adını değiştir" onClick={() => adAc('kampanya', k, yukle)} style={AD_DUGME}>✎</button>
                  <span style={ROZET(k.durum)}>{k.durum}</span>
                </div>

                {dal?.acik && (
                  <div style={{ paddingLeft: 26, paddingBottom: 6 }}>
                    {dal.yukleniyor && <div style={{ fontSize: 11.5, color: 'var(--text-muted)', padding: '4px 12px' }}>⏳ setler okunuyor...</div>}
                    {suz(dal.cocuklar).length === 0 && !dal.yukleniyor && <div style={{ fontSize: 11.5, color: "var(--text-muted)", padding: "4px 12px" }}>{sadeceAktif ? "Yayında set yok." : "Set yok."}</div>}
                    {suz(dal.cocuklar).map(st => {
                      const alt = reklamlar[st.id];
                      return (
                        <div key={st.id}>
                          <div style={SATIR(1)}>
                            <button onClick={() => reklamlariAc(st)} style={{
                              width: 20, height: 20, border: '1px solid var(--border)', background: '#fff',
                              borderRadius: 5, cursor: 'pointer', fontSize: 12, lineHeight: 1, flexShrink: 0,
                            }}>{alt?.acik ? '−' : '+'}</button>
                            <button onClick={() => klonAc('set', st, k.id, k.ad)} style={KLON_DUGME}>KLONLA</button>
                            <button disabled={durumIslemde === st.id}
                              onClick={() => durumDegistir('set', st, st.durum !== 'ACTIVE', () => setleriTazele(k.id))}
                              style={DURUM_DUGME(st.durum === 'ACTIVE')}>
                              {st.durum === 'ACTIVE' ? 'PASİF YAP' : 'AKTİF YAP'}
                            </button>
                            <span style={{ fontSize: 12.5 }}>{st.ad}</span>
                            <button title="adını değiştir" onClick={() => adAc('set', st, () => setleriTazele(k.id))} style={AD_DUGME}>✎</button>
                            <span style={ROZET(st.durum)}>{st.durum}</span>
                            {st.gunlukButceKurus != null && (
                              <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{para(st.gunlukButceKurus)}/gün</span>
                            )}
                          </div>

                          {alt?.acik && (
                            <div style={{ paddingLeft: 26 }}>
                              {alt.yukleniyor && <div style={{ fontSize: 11, color: 'var(--text-muted)', padding: '3px 12px' }}>⏳ reklamlar okunuyor...</div>}
                              {suz(alt.cocuklar).length === 0 && !alt.yukleniyor && <div style={{ fontSize: 11, color: "var(--text-muted)", padding: "3px 12px" }}>{sadeceAktif ? "Yayında reklam yok." : "Reklam yok."}</div>}
                              {suz(alt.cocuklar).map(r => (
                                <div key={r.id} style={SATIR(2)}>
                                  <span style={{ fontSize: 12, color: 'var(--text-muted)', width: 20, flexShrink: 0, textAlign: 'center' }}>↳</span>
                                  <button onClick={() => klonAc('reklam', r, st.id, st.ad)} style={KLON_DUGME}>KLONLA</button>
                                  <button disabled={durumIslemde === r.id}
                                    onClick={() => durumDegistir('reklam', r, r.durum !== 'ACTIVE', () => reklamlariTazele(st.id))}
                                    style={DURUM_DUGME(r.durum === 'ACTIVE')}>
                                    {r.durum === 'ACTIVE' ? 'PASİF YAP' : 'AKTİF YAP'}
                                  </button>
                                  <button onClick={() => onizlemeAc(r)} style={{
                                    border: 'none', background: 'none', color: '#1F6FB2', fontSize: 11,
                                    textDecoration: 'underline', cursor: 'pointer', padding: 0, flexShrink: 0,
                                  }}>reklamı göster</button>
                                  <span style={{ fontSize: 12 }}>{r.ad}</span>
                                  <button title="adını değiştir" onClick={() => adAc('reklam', r, () => reklamlariTazele(st.id))} style={AD_DUGME}>✎</button>
                                  <span style={ROZET(r.durum)}>{r.durum}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* REKLAMIN GÖRÜNTÜSÜ (kullanıcı talebi: 2026-09-06). Meta'nın fb.me bağlantısı
          Facebook'ta ayrı bir izin ekranına düşürüyordu; burada gömülü çerçeveyi gösteriyoruz. */}
      {onizleme && (
        <div onClick={() => setOnizleme(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(20,30,28,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, width: 'min(900px, 100%)', maxHeight: '90vh',
            overflow: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          }}>
            <div style={{
              padding: '13px 18px', borderBottom: '1px solid var(--border)',
              display: 'flex', alignItems: 'center', gap: 10, position: 'sticky', top: 0, background: '#fff',
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 700 }}>{onizleme.reklam.ad}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{onizleme.reklam.durum}</div>
              </div>
              <button onClick={() => setOnizleme(null)} style={{
                background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)',
              }}>×</button>
            </div>

            <div style={{ padding: 18 }}>
              {onizleme.yukleniyor && <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>⏳ Meta'dan önizleme isteniyor...</div>}
              {onizleme.hata && (
                <div style={{
                  fontSize: 12.5, color: '#C0392B', background: '#FDECEA',
                  border: '1px solid #E6A9A2', borderRadius: 6, padding: '9px 12px',
                }}>✗ {onizleme.hata}</div>
              )}
              <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                {onizleme.kareler?.map(k => (
                  <div key={k.yerlesim}>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 5 }}>{k.ad}</div>
                    <iframe title={k.ad} src={k.adres} frameBorder="0" scrolling="yes"
                      style={{ width: 340, height: 620, border: '1px solid var(--border)', borderRadius: 8 }} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* AD DEĞİŞTİRME PENCERESİ (kullanıcı talebi: 2026-09-06) */}
      {adDegis && (
        <div onClick={() => !adKaydediliyor && setAdDegis(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(20,30,28,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, width: 'min(520px, 100%)', padding: 20,
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 3 }}>
              {adDegis.tur === 'kampanya' ? 'Kampanya' : adDegis.tur === 'set' ? 'Reklam seti' : 'Reklam'} adını değiştir
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginBottom: 14 }}>
              Ad yalnızca etikettir — yayını, bütçeyi ve öğrenme evresini etkilemez.
            </div>

            <input value={yeniAd} onChange={e => setYeniAd(e.target.value)} autoFocus
              onKeyDown={e => { if (e.key === 'Enter' && yeniAd.trim().length >= 2 && !adKaydediliyor) adKaydet(); }}
              style={{
                width: '100%', padding: '8px 10px', fontSize: 13, borderRadius: 6,
                border: '1px solid var(--border)', marginBottom: 14,
              }} />

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setAdDegis(null)} disabled={adKaydediliyor} style={{
                border: '1px solid var(--border)', background: '#fff', color: 'var(--text-muted)',
                borderRadius: 6, padding: '8px 14px', fontSize: 12.5, cursor: 'pointer',
              }}>Vazgeç</button>
              <button onClick={adKaydet} disabled={adKaydediliyor || yeniAd.trim().length < 2} style={{
                border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 12.5, fontWeight: 700,
                background: (adKaydediliyor || yeniAd.trim().length < 2) ? '#E4E9EA' : '#1D9E75',
                color: (adKaydediliyor || yeniAd.trim().length < 2) ? '#9AA7AC' : '#fff',
                cursor: (adKaydediliyor || yeniAd.trim().length < 2) ? 'default' : 'pointer',
              }}>{adKaydediliyor ? 'KAYDEDİLİYOR...' : 'KAYDET'}</button>
            </div>
          </div>
        </div>
      )}

      {/* KLON PENCERESİ — ad sorulur, gerekiyorsa reklamlar da kopyalanır */}
      {klon && (
        <div onClick={() => !klonlaniyor && setKlon(null)} style={{
          position: 'fixed', inset: 0, background: 'rgba(20,30,28,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 10, width: 'min(520px, 100%)', padding: 20,
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 3 }}>
              {klon.tur === 'kampanya' ? 'Kampanya' : klon.tur === 'set' ? 'Reklam seti' : 'Reklam'} klonla
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginBottom: 14 }}>
              Kaynak: <strong>{klon.dugum.ad}</strong>
              {klon.hedefAdi && <> · kopya <strong>{klon.hedefAdi}</strong> içinde açılacak</>}
            </div>

            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 3 }}>Yeni ad</div>
            <input value={klonAd} onChange={e => setKlonAd(e.target.value)} autoFocus
              onKeyDown={e => { if (e.key === 'Enter' && klonAd.trim().length >= 2 && !klonlaniyor) klonla(); }}
              style={{
                width: '100%', padding: '8px 10px', fontSize: 13, borderRadius: 6,
                border: '1px solid var(--border)', marginBottom: 12,
              }} />

            {klon.tur === 'set' && (
              <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 7, marginBottom: 12, cursor: 'pointer' }}>
                <input type="checkbox" checked={klonReklamlar} onChange={e => setKlonReklamlar(e.target.checked)} />
                İçindeki reklamlar da kopyalansın
              </label>
            )}

            <div style={{
              fontSize: 11.5, color: '#8A6D1F', background: '#FFF6E5', border: '1px solid #E8C468',
              borderRadius: 6, padding: '8px 11px', marginBottom: 14,
            }}>
              Kopya <strong>durdurulmuş</strong> açılır, kaynağa dokunulmaz. Yeni set sıfırdan
              öğrenme aşamasına girer — ilk günlerde maliyet yüksek görünebilir.
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setKlon(null)} disabled={klonlaniyor} style={{
                border: '1px solid var(--border)', background: '#fff', color: 'var(--text-muted)',
                borderRadius: 6, padding: '8px 14px', fontSize: 12.5, cursor: 'pointer',
              }}>Vazgeç</button>
              <button onClick={klonla} disabled={klonlaniyor || klonAd.trim().length < 2} style={{
                border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 12.5, fontWeight: 700,
                background: (klonlaniyor || klonAd.trim().length < 2) ? '#E4E9EA' : '#1D9E75',
                color: (klonlaniyor || klonAd.trim().length < 2) ? '#9AA7AC' : '#fff',
                cursor: (klonlaniyor || klonAd.trim().length < 2) ? 'default' : 'pointer',
              }}>{klonlaniyor ? 'KLONLANIYOR...' : 'KLONLA'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
